import * as React from "react";

import { HashTag } from "./HashTag";
import { TagElement } from "@/interfaces";

import "./styles.scss";
import { removeWhiteSpace, useComplianceChecker } from "@/utils";

interface OwnProps {
  title: string;
  coachId: number;
  defaultHashtagList?: string;
  onError: (keywords: string[]) => void;
  onSuccess: (newTags: TagElement[]) => void;
  addHashtagOnChange?: (checked: boolean) => void;
}

type Props = OwnProps;

export const HashTagSet: React.FC<Props> = ({ title, defaultHashtagList, coachId, onError, onSuccess }) => {
  const { blockedPhrases } = useComplianceChecker({ coachId });

  const hashTagsAsTags = (hashtagsString?: string): TagElement[] => {
    let hashtagsElements: TagElement[] = [];

    if (hashtagsString) {
      const hashtagsList = hashtagsString.trim().split(" ");
      hashtagsElements = hashtagsList
        .map((hashtag, index) => {
          const displayValue = removeWhiteSpace(hashtag.replace("#", ""));
          if (displayValue === "") {
            return null;
          }

          const tagElement: TagElement = {
            index,
            displayValue,
            id: `${index}`,
          };
          return tagElement;
        })
        .filter(Boolean) as TagElement[];

      return hashtagsElements;
    }

    return hashtagsElements;
  };

  const [tagList, setTagList] = React.useState<TagElement[]>([]);

  React.useEffect(() => {
    setTagList(hashTagsAsTags(defaultHashtagList));
  }, [defaultHashtagList]);

  const validateNewInput = (newValues: TagElement[]): void => {
    onSuccess(newValues);
  };

  return (
    <div
      className={"flex flex-col border border-slate-300 shadow-none rounded bg-white"}
      data-elm-id={"promptHashtagsSet"}
    >
      <HashTag
        dataElmId={"coachPromptHashtags"}
        placeholder={title}
        tags={tagList}
        unavailableTags={blockedPhrases}
        onTagsChanged={validateNewInput}
        onInputRepeatedError={onError}
      />
    </div>
  );
};
